<template>
  <div>
    <div class="va-row">
      <div class="flex xs12 md12">
        <vuestic-widget :headerText="$t('recurring.orderInformation')" class="order-info">
          <div class="table-responsive">
            <table class="table table-striped first-td-padding">
              <thead>
                <tr>
                  <th>{{ $t("tables.detailsInfo.transactionID") }}</th>
                  <th>{{ $t("tables.listing.recurring_merchant_reference") }}</th>
                  <th>{{ $t("t.status") }}</th>
                  <th>{{ $t("tables.listing.recurring_create_time") }}</th>
                  <th>{{ $t("t.method") }}</th>
                  <th>{{ $t("tables.listing.recurring_order_amount") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in orderInformation" :key="idx">
                  <td> {{ item.transactionID }} </td>
                  <td> {{ item.merchantReference }} </td>
                  <td> {{ item.status }} </td>
                  <td> {{ item.createTime }} </td>
                  <td> {{ item.method }} </td>
                  <td> {{ item.orderAmount }}1 </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="order-info-buttons">
            <button class="btn btn-primary btn-micro mr-2"
              v-if="detailMethod && isRefund === 'Refund'"
              :disabled="!refundCanDo"
              :class="{ disable: !refundCanDo }"
              @click="showMediumModal">
              <div class="btn-with-icon-content">
                {{ "basic.button.refund" | translate }}
              </div>
            </button>
            <!-- <button class="btn btn-primary btn-micro" v-else-if="isRefund === 'Callback'">
              <div class="btn-with-icon-content">
                {{ "basic.button.callback" | translate }}
              </div>
            </button> -->
            <button
              v-else
              class="btn btn-info btn-micro"
              @click="callbackOrderStatus"
              :disabled="isLoading"
            >
              {{ isLoading ? "" : "callback" }}
              <span v-if="isLoading">{{ $t("loading") }}</span>
            </button>
          </div>
        </vuestic-widget>
      </div>
    </div>
    <div class="va-row">
      <div class="flex xs12 md12">
        <vuestic-widget :headerText="$t('recurring.productInformation')">
          <div class="table-responsive">
            <table class="table table-striped first-td-padding">
              <thead>
                <tr>
                  <th>{{ $t("tables.listing.app_name") }}</th>
                  <th>{{ $t("tables.apping.appId") }}</th>
                  <th>{{ $t("tables.listing.subject") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in productInformation" :key="idx">
                  <td> {{ item.appName }} </td>
                  <td> {{ item.appId }} </td>
                  <td> {{ item.subject }} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </vuestic-widget>
      </div>
    </div>
    <div class="va-row">
      <div class="flex xs12 md12">
        <vuestic-widget :headerText="$t('recurring.statusHistory')">
          <div class="table-responsive">
            <table class="table table-striped first-td-padding">
              <thead>
                <tr>
                  <th>{{ $t("t.status") }}</th>
                  <th>{{ $t("tables.listing.updateTime") }}</th>
                  <th>{{ $t("t.amount") }}</th>
                  <th>{{ $t("tables.detailsInfo.cbStatus") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in statusHistory" :key="idx">
                  <td> {{ item.status }} </td>
                  <td> {{ item.updateTime }} </td>
                  <td> {{ item.amount }} </td>
                  <td> {{ item.callbackStatus }} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </vuestic-widget>
      </div>
    </div>

    <div class="va-row">
      <div class="flex xs12 md12">
        <vuestic-widget :headerText="$t('recurring.buyerInformation')">
          <div class="table-responsive">
            <table class="table table-striped first-td-padding">
              <thead>
                <tr>
                  <th>{{ $t("payment.buyerName") }}</th>
                  <th>{{ $t("cpfCnpj") }}</th>
                  <th>{{ $t("tables.listing.recurring_buyer_id") }}</th>
                  <th>{{ $t("payment.cellNumber") }}</th>
                  <th>{{ $t("contactEmail") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in buyerInformation" :key="idx">
                  <td> {{ item.buyerName }} </td>
                  <td> {{ item.cpfCNPJ }} </td>
                  <td> {{ item.buyerID }} </td>
                  <td> {{ item.cellNumber }} </td>
                  <td> {{ item.contactEmail }} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </vuestic-widget>
        <div class="va-row" v-if="refusedFg">
          <div class="flex xs12 md6">
            <vuestic-widget :headerText="$t('tables.antiFraud')">
              <div class="refused-info">
                <ul style="width: 70%">
                  <li class="oneline-voucher">
                    <span>{{ $t("tables.refusedInfo") }}：</span>
                    <span v-text="refusedInfo"></span>
                  </li>
                </ul>
              </div>
            </vuestic-widget>
          </div>
        </div>
      </div>
    </div>

    <div class="modals-page" id="refundReason">
      <vuestic-modal
        :show.sync="show"
        ref="mediumModal"
        :okText="'modal.confirm2' | translate"
        style="height: 100%; width: 60vw"
        :okClass="'btn btn-primary btn-micro'"
        :cancelClass="'btn btn-secondary btn-micro'"
        :cancelText="'modal.cancel2' | translate"
        @cancel="handleModalClose"
      >
        <div slot="title">{{ "modal.refundReason" | translate }}</div>
        <div>
          <form>
            <div class="va-row">
              <div class="flex xs12 md12">
                <fieldset>
                  <div
                    class="form-group with-icon-right"
                    :class="{
                      'has-error': errors.has('refundAmount'),
                      valid: isFormFieldValid('refundAmount'),
                    }"
                  >
                    <div class="input-group">
                      <input
                        id="simple-input"
                        name="refundAmount"
                        data-vv-as="Name"
                        v-model="refundAmount"
                        v-validate="'required'"
                        autocomplete="off"
                        required
                      />
                      <i
                        class="
                          fa fa-exclamation-triangle
                          error-icon
                          icon-right
                          input-icon
                        "
                      ></i>
                      <i
                        class="fa fa-check valid-icon icon-right input-icon"
                      ></i>
                      <label class="control-label" for="simple-input"
                        >{{
                          "forms.inputs.refundAmount" | translate
                        }}：</label
                      ><i class="bar"></i>
                      <small
                        v-show="errors.has('refundAmount')"
                        class="help text-danger"
                      >
                        {{ errors.first("refundAmount") }}
                      </small>
                    </div>
                  </div>
                  <div
                    class="form-group with-icon-right"
                    :class="{
                      'has-error': errors.has('successfulEmail'),
                      valid: isSuccessfulEmailValid,
                    }"
                  >
                    <div class="input-group">
                      <input
                        id="successfulEmail"
                        name="successfulEmail"
                        v-model="successfulEmail"
                        v-validate="'required|email'"
                        autocomplete="off"
                        required
                      />
                      <i
                        class="
                          fa fa-exclamation-triangle
                          error-icon
                          icon-right
                          input-icon
                        "
                      ></i>
                      <i
                        class="fa fa-check valid-icon icon-right input-icon"
                      ></i>
                      <label class="control-label" for="successfulEmail">
                        {{ "forms.inputs.buyerEmail" | translate }}：
                      </label>
                      <i class="bar" />
                      <small
                        v-show="errors.has('successfulEmail')"
                        class="help text-danger"
                      >
                        {{ errors.first("successfulEmail") }}
                      </small>
                    </div>
                  </div>

                  <div
                    class="form-group with-icon-right"
                    :class="{
                      'has-error': errors.has('refundExplain'),
                      valid: isFormFieldValid('refundExplain'),
                    }"
                  >
                    <div class="input-group">
                      <textarea
                        type="text"
                        name="refundExplain"
                        data-vv-as="Name"
                        id="simple-textarea"
                        v-model="refundExplain"
                        :placeholder="$t('payment.upTo100Characters')"
                        maxlength="100"
                        rows="2"
                        :style="paddTop"
                        @focus="resizeLabel"
                        @blur="focusLabel"
                        v-validate="'required'"
                        required
                      >
                      </textarea>
                      <i
                        class="
                          fa fa-exclamation-triangle
                          error-icon
                          icon-right
                          input-icon
                        "
                      ></i>
                      <i
                        class="fa fa-check valid-icon icon-right input-icon"
                      ></i>
                      <label class="control-label" for="simple-textarea"
                        >{{
                          "forms.inputs.description" | translate
                        }}：</label
                      ><i class="bar"></i>
                      <small
                        v-show="errors.has('refundExplain')"
                        class="help text-danger"
                      >
                        {{ errors.first("refundExplain") }}
                      </small>
                    </div>
                    <!-- <div class="flex md12 xs12" id="textareawrapper">
                    </div> -->
                  </div>
                  <div
                    class="form-group with-icon-right"
                    v-if="speiFlag"
                    :class="{
                      'has-error': errors.has('bank'),
                      valid: isFormFieldValid('bank'),
                    }"
                  >
                    <div class="input-group">
                      <el-select
                        id="bank"
                        name="bank"
                        v-model="bankCode"
                        :filterable="true"
                        v-validate="'required'"
                        required
                        :placeholder="$t('payment.pleaseSelectABank')"
                        @change="selectBankCode"
                      >
                        <el-option
                          v-for="item in bankCodeList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                      <i
                        class="
                          fa fa-exclamation-triangle
                          error-icon
                          icon-right
                          input-icon
                        "
                      ></i>
                      <i
                        class="fa fa-check valid-icon icon-right input-icon"
                      ></i>
                      <i class="bar" />
                      <small
                        v-show="errors.has('bank')"
                        class="help text-danger"
                      >
                        {{ errors.first("bank") }}
                      </small>
                    </div>
                  </div>
                  <div
                    class="form-group with-icon-right"
                    v-if="speiFlag"
                    :class="{
                      'has-error': errors.has('clabe'),
                      valid: isFormFieldValid('clabe'),
                    }"
                  >
                    <div class="input-group">
                      <input
                        id="clabe"
                        name="clabe"
                        v-model="clabe"
                        v-validate="'required'"
                        autocomplete="off"
                        required
                      />
                      <i
                        class="
                          fa fa-exclamation-triangle
                          error-icon
                          icon-right
                          input-icon
                        "
                      ></i>
                      <i
                        class="fa fa-check valid-icon icon-right input-icon"
                      ></i>
                      <label class="control-label" for="clabe">
                        CLABE：
                      </label>
                      <i class="bar" />
                      <small
                        v-show="errors.has('clabe')"
                        class="help text-danger"
                      >
                        {{ errors.first("clabe") }}
                      </small>
                    </div>
                  </div>

                  <!-- 这一块打算添加上对现金支付的申请用的字段 TODO -->
                  <vuestic-checkbox
                    ref="other"
                    v-if="checkCanRefund() && !speiFlag"
                    :label="$t('forms.controls.options')"
                    v-model="checkboxOption"
                  />
                  <div id="user_info" class="" v-if="dispalyOtherFg">
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('username'),
                        valid: isFormFieldValid('username'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="uname-input"
                          name="username"
                          data-vv-as="Name"
                          v-model="username"
                          v-validate="'required'"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="uname-input"
                          >{{ "forms.inputs.username" | translate }}：</label
                        ><i class="bar"></i>
                        <small
                          v-show="errors.has('username')"
                          class="help text-danger"
                        >
                          {{ errors.first("username") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('cpfNO'),
                        valid: isFormFieldValid('cpfNO'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="cpfNO-input"
                          name="cpfNO"
                          data-vv-as="Name"
                          v-model="cpfNO"
                          v-validate="'required'"
                          maxlength="14"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="cpfNO-input"
                          >{{ "forms.inputs.cpfNO" | translate }}：</label
                        ><i class="bar"></i>
                        <small
                          v-show="errors.has('cpfNO')"
                          class="help text-danger"
                        >
                          {{ errors.first("cpfNO") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      :class="{
                        'has-error': errors.has('agency'),
                        valid: isFormFieldValid('agency'),
                      }"
                    >
                      <div class="input-group">
                        <input
                          id="agency-input"
                          name="agency"
                          data-vv-as="Name"
                          v-model="agency"
                          v-validate="'required'"
                          maxlength="6"
                          onkeyup="this.value=this.value.replace(/[^a-zA-Z0-9\-]/g,'')"
                          ondragenter="return false"
                          ondragover="return false"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="agency-input"
                          >{{ "forms.inputs.agency" | translate }}：</label
                        ><i class="bar"></i>
                        <small
                          v-show="errors.has('agency')"
                          class="help text-danger"
                        >
                          {{ errors.first("agency") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      id="bankWrapper"
                      :class="{
                        'has-error': initSelectedVaild,
                        valid: isBankVaild(selBank),
                      }"
                    >
                      <div class="input-group">
                        <vuestic-simple-select
                          :label="$t('forms.inputs.bank')"
                          name="selBank"
                          data-vv-as="Name"
                          v-model="selBank"
                          ref="bankInput"
                          @input="forbiddenInput"
                          autocomplete="off"
                          v-validate="'required'"
                          required
                          option-key="description"
                          v-bind:options="bankOptions"
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <small
                          v-show="initSelectedVaild"
                          class="help text-danger"
                          style="display: block; margin-top: -30px"
                        >
                          {{ errors.first("selBank") }}
                        </small>
                      </div>
                    </div>
                    <div
                      class="form-group with-icon-right"
                      id="accountWrapper"
                      :class="{
                        'has-error': initSelAccoutTypeVaild,
                        valid: isAccountVaild(accountType),
                      }"
                    >
                      <div class="input-group">
                        <vuestic-simple-select
                          :label="$t('forms.inputs.accountType')"
                          name="accountType"
                          data-vv-as="Name"
                          v-model="accountType"
                          ref="accountInput"
                          @input="forbiddenAccountInput"
                          autocomplete="off"
                          v-validate="'required'"
                          required
                          option-key="description"
                          v-bind:options="accountOptions"
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <small
                          v-show="initSelAccoutTypeVaild"
                          class="help text-danger"
                          style="display: block; margin-top: -30px"
                        >
                          {{ errors.first("accountType") }}
                        </small>
                      </div>
                    </div>
                    <div class="form-group with-icon-right">
                      <div class="input-group">
                        <input
                          id="card_number"
                          name="card_number"
                          data-vv-as="Name"
                          v-model="bankAccountNumberFirst"
                          v-validate="'required'"
                          style="display: inline-block; width: 60%"
                          onpaste="return false"
                          ondragenter="return false"
                          ondragover="return false"
                          maxlength="14"
                          @focus="formatCardNumber($event)"
                          required
                        />
                        <span>—</span>
                        <input
                          id="branch_num"
                          name="branch_num"
                          data-vv-as="Name"
                          v-model="bankAccountNumberLast"
                          v-validate="'required'"
                          style="
                            display: inline-block;
                            width: 20%;
                            padding-left: 10px;
                          "
                          maxlength="2"
                          onkeyup="this.value=this.value.replace(/\D/g,'')"
                          onkeydown="this.value=this.value.replace(/\D/g,'')"
                          onpaste="return false"
                          ondragenter="return false"
                          ondragover="return false"
                          required
                        />
                        <i
                          class="
                            fa fa-exclamation-triangle
                            error-icon
                            icon-right
                            input-icon
                          "
                        ></i>
                        <i
                          class="fa fa-check valid-icon icon-right input-icon"
                        ></i>
                        <label class="control-label" for="card_number"
                          >{{
                            "forms.inputs.bankAccountNumber" | translate
                          }}：</label
                        ><i class="bar"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group with-icon-right"
                    :class="{
                      'has-error': errors.has('userPass'),
                      valid: isFormFieldValid('userPass'),
                    }"
                  >
                    <div class="input-group">
                      <input
                        name="userPass"
                        data-vv-as="Password"
                        type="password"
                        id="password"
                        v-model="userPass"
                        v-validate="'required'"
                        required="required"
                        autocomplete = "new-password"
                        onkeyup="value=value.replace(/\s/g,'')"
                        onkeydown="value=value.replace(/\s/g,'')"
                      />
                      <i
                        class="
                          fa fa-exclamation-triangle
                          error-icon
                          icon-right
                          input-icon
                        "
                      ></i>
                      <i
                        class="fa fa-check valid-icon icon-right input-icon"
                      ></i>
                      <label class="control-label" for="password">
                        {{ $t("auth.password") }}：
                      </label>
                      <i class="bar" />
                      <small
                        v-show="errors.has('userPass')"
                        class="help text-danger"
                        >{{ errors.first("userPass") }}</small
                      >
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </form>
        </div>
      </vuestic-modal>
    </div>


  </div>
</template>

<script>
import {
  request,
  formatUserCredentials,
} from "@/utils/utils.js";
var moment = require("moment-timezone");
export default {
  name: "PaymentOrderDetail",
  data() {
    return {
      orderInformation: [
        {
          transactionID: "",
          merchantReference: "",
          status: "",
          createTime: "",
          method: "",
          orderAmount: "",
        },
      ],
      productInformation: [
        {
          appName: "",
          appId: "",
          subject: ""
        }
      ],
      statusHistory: [
        {
          status: "",
          updateTime: "",
          amount: "",
          callbackStatus: "",
        }
      ],
      buyerInformation: [
        {
          buyerName: "",
          cpfCNPJ: "",
          buyerID: "",
          cellNumber: "",
          contactEmail: ""
        }
      ],
      refusedInfo: "error",
      refusedFg: false,
      detailMethod: "",
      isRefund: false,
      refundCanDo: true,
      // modal
      refundAmount: "",
      successfulEmail: "",
      refundExplain: "",
      bankCode: "",
      clabe: "",
      checkboxOption: "",
      username: "",
      cpfNO: "",
      agency: "",
      selBank: "",
      accountType: "",
      bankAccountNumberFirst: "",
      bankAccountNumberLast: "",
      userPass: "",

      show: true,
      paddTop: {
        "padding-top": "18px",
      },
      isLoading: false,

      out_trade_no: "",
      app_id: "",
      speiFlag: false,
      dispalyOtherFg: false,
      checkboxOption: false,
    }
  },
  mounted() {
    this.initPaymentOrderDetail();
  },
  methods: {
    initPaymentOrderDetail() {
      let trade_no = this.$route.query.trade_no;
      let token = localStorage.getItem("Authorization");
      let that = this;
      that.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half");
      request({
        method: "post",
        url: `api/dashboard/order/queryById?tid=${trade_no}&access_token=${token}`,
        headers: {
          "Content-Type": "application/json",
        },
      }).then((res) => {
        if (res.status === 200) {
          let data = res.data;
          if (data.code === "10000") {
            let orderData = data.data;
            // Order Information
            that.renderOrderInfo(orderData);
            // Product Information
            that.renderProductInfo(orderData);
            // Status History
            that.renderStatusHistory(orderData);
            // Buyer Information
            that.renderBuyerInformation(orderData);
          }
        } else {
          that.showToast("System error, please refresh and try again!", {
            icon: "fa-exclamation-circle",
            position: "bottom-center",
            duration: "3000",
            fullWidth: true
          });
        }
        that.searching.close();
      })
    },
    renderOrderInfo(orderData) {
      let oInfo = {};
      oInfo.transactionID = orderData.detail.trade_no
          ? orderData.detail.trade_no
          : "N/A";
      oInfo.merchantReference = orderData.detail.out_trade_no
          ? orderData.detail.out_trade_no
          : "N/A";
      oInfo.status = orderData.detail.trans_base.trade_status
          ? orderData.detail.trans_base.trade_status
          : "N/A";
      oInfo.createTime = orderData.detail.trans_base.create_time
          ? this.dateFormat(orderData.detail.trans_base.create_time)
          : "N/A";
      oInfo.method = orderData.detail.trans_base.method
          ? orderData.detail.trans_base.method
          : "N/A";
      oInfo.orderAmount = orderData.detail.trans_base.order_currency &&
          orderData.detail.trans_base.order_amount
            ? `${orderData.detail.trans_base.order_currency} ${orderData.detail.trans_base.order_amount}`
            : "N/A";
      this.$set(this.orderInformation,0, oInfo);

      this.out_trade_no = orderData.detail.out_trade_no
      this.app_id = orderData.detail.trans_base.app_id
      this.speiFlag = orderData.detail.trans_base.method == "SPEI" ? true : false;
      this.detailMethod = [
        "CreditCard",
        "Boleto",
        "Lottery",
        "DepositExpress",
        "PIX",
        "Pix",
        "Wallet",
        "SPEI",
      ].includes(orderData.detail.trans_base.method);
      if (this.detailMethod === true &&
        (orderData.detail.trans_base.trade_status === "Success" ||
          orderData.detail.trans_base.trade_status === "PartialRefund")) {
            this.isRefund = 'Refund'
      } else {
        this.isRefund = ''
      }
    },
    renderProductInfo(orderData) {
      let pInfo = {};
      pInfo.appName = orderData.detail.trans_base.app_name
          ? orderData.detail.trans_base.app_name
          : "N/A";
      pInfo.appId = orderData.detail.trans_base.app_id
          ? orderData.detail.trans_base.app_id
          : "N/A";
      pInfo.subject = orderData.detail.trans_base.subject
          ? orderData.detail.trans_base.subject
          : "N/A";
      this.$set(this.productInformation,0, pInfo);
    },
    renderStatusHistory(orderData) {
      for (let i = 0; i < orderData.detail.trans_logs.length; i++) {
        let sHistory = {};
        let refundMoney = orderData.detail.trans_logs[i].amount
                    ? orderData.detail.trans_logs[i].currency +
                      " " +
                      orderData.detail.trans_logs[i].amount
                    : orderData.detail.trans_base.order_amount
                    ? orderData.detail.trans_base.order_currency +
                      " " +
                      orderData.detail.trans_base.order_amount
                    : "N/A";
        sHistory.status = orderData.detail.trans_logs[i].log_status
                      ? orderData.detail.trans_logs[i].log_status
                      : "N/A";
        sHistory.updateTime = orderData.detail.trans_logs[i].create_time
                      ? this.dateFormat(
                          orderData.detail.trans_logs[i].create_time
                        )
                      : "N/A";
        sHistory.amount = refundMoney;
        sHistory.callbackStatus = orderData.detail.trans_logs[i].log_callback_status
                      ? orderData.detail.trans_logs[i].log_callback_status
                      : "N/A";
        this.$set(this.statusHistory,i, sHistory);
      }
    },
    renderBuyerInformation(orderData) {
      let bInfo = {};
      if (orderData.detail.trans_base) {
        if (orderData.detail.trans_base.payment_info) {
          var amountMoney = "N/A";
          var amountCurrency = "";
          var payAmount = {
            type: "",
            number: "",
          };
          var payIdentify =
            orderData.detail.trans_base.payment_info.identify;
          if (payIdentify) {
            if (typeof payIdentify === "string") {
              amountCurrency =
                orderData.detail.trans_base.payment_info.currency;
              if (payIdentify.length <= 12) {
                payAmount = {
                  type: "cpf",
                  number: payIdentify,
                };
              } else if (payIdentify.length > 13) {
                payAmount = {
                  type: "cnpj",
                  number: payIdentify,
                };
              }
            } else if (
              Object.prototype.toString.call(payIdentify) ===
              "[object Object]"
            ) {
              payAmount = {
                type: payIdentify.type,
                number: payIdentify.number,
              };
            }
          }
          bInfo.buyerName = orderData.detail.trans_base.payment_info.buyer_name ||
              "N/A";
          bInfo.cpfCNPJ = payIdentify ? formatUserCredentials(payAmount.type, payAmount.number)
              : "N/A";
          bInfo.buyerID = (orderData.detail.trans_base.user_info
                ? orderData.detail.trans_base.user_info.buyer_id
                : "N/A") || "N/A";
          bInfo.cellNumber = orderData.detail.trans_base.payment_info.phone || "N/A";
          bInfo.contactEmail = orderData.detail.trans_base.payment_info.email || "N/A";
        } else {
          bInfo.buyerName = "N/A";
          bInfo.cpfCNPJ = "N/A";
          bInfo.buyerID = (orderData.detail.trans_base.user_info
                ? orderData.detail.trans_base.user_info.buyer_id
                : "N/A") || "N/A";
          bInfo.cellNumber = "N/A";
          bInfo.contactEmail = "N/A";
        }
        if (orderData.detail) {
          if (orderData.detail.trans_logs) {
            if (
              orderData.detail.trans_logs[0].log_status === "Refused"
            ) {
              this.refusedFg = true;
              if (orderData.risk) {
                this.refusedInfo = orderData.risk.refuseInfo || "N/A";
              } else {
                this.refusedInfo = "N/A";
              }
            }
          }
        }
      }
      this.$set(this.buyerInformation,0, bInfo);
    },
    loadingFullScreen(controller, txt, className) {
      this[controller] = this.$loading({
        lock: true,
        text: txt,
        spinner: className,
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    dateFormat(value) {
      return moment
        .tz(moment.tz(value, "UTC"), this.currTimeZone)
        .format("YYYY-MM-DD HH:mm:ss");
    },
    showMediumModal() {
      // this.refundMount = this.successfulEmail = this.refundExplain = this.single = this.userPass = ''
      this.single =
      this.userPass =
      this.username =
      this.cpfNO =
      this.agency =
      this.selBank =
      this.accountType =
      this.bankAccountNumberFirst =
      this.bankAccountNumberLast =
      this.clabe =
      this.bankCode =
        "";
      this.selectedBank = {};
      if (
        this.orderInformation[0].method === "CreditCard" ||
        this.orderInformation[0].method === "Wallet"
      ) {
        this.checkboxOption = false;
        this.$refs.mediumModal.open();
        this.$refs.mediumModal.style = "";
        // 限制拒绝退款的调用频率
        var callFrequency2Refund = {
          orderId: this.orderInformation[0].transactionID,
          dataTime: new Date().getTime(), //  每1分钟才能重发
          countCk: 0,
        };
        this.$refs.mediumModal.ok = (callFrequency2Refund) => {
          this.toSubmitRefundData(callFrequency2Refund);
        };
      } else if (this.checkCanRefund()) {
        // TODO
        this.$refs.mediumModal.open();
        this.$refs.mediumModal.style = "";
        // 限制拒绝退款的调用频率
        var callFrequency2Refund = {
          orderId: this.orderInformation[0].transactionID,
          dataTime: new Date().getTime(), //  每1分钟才能重发
          countCk: 0,
        };
        this.$refs.mediumModal.ok = (callFrequency2Refund) => {
          this.toSubmitRefundData(callFrequency2Refund, this.checkboxOption);
        };
      } else {
        return;
      }
    },
    callbackOrderStatus () {
      this.isLoading = true
      let token = localStorage.getItem('Authorization')
      let out_trade_no = this.out_trade_no
      let app_id = this.app_id
      request({
        method: 'post',
        url: `api/dashboard/order/callback?access_token=${token}&app_id=${app_id}&out_trade_no=${out_trade_no}`,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        let code = res.data.code
        if (code == 10000) {
          this.toastText = res.data.msg || 'Success!'
          this.launchToast()
          setTimeout(() => {
            this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half")
            this.orderData()
          }, 20);
        } else {
          this.toastText = res.data.msg
          this.launchToast()
        }
        this.isLoading = false
      }).catch(err => {
        this.toastText = err.msg
        this.launchToast()
        this.isLoading = false
      })
    },
    // 退款confirm 点击事件
    toSubmitRefundData(callBkObj, others) {
      if (this.refundCanDo === false) {
        return;
      }
      if (!this.refundAmount) {
        return;
      }
      if (!this.successfulEmail) {
        return;
      }
      if (!this.refundExplain) {
        return;
      }
      if (!this.userPass) {
        return;
      }
      // 其他现金支付提交
      if (others) {
        if (this.dispalyOtherFg) {
          if (!this.username) {
            return;
          }
          if (!this.cpfNO) {
            return;
          }
          if (!this.agency) {
            return;
          }
          if (!this.selBank) {
            return;
          }
          if (!this.accountType) {
            return;
          }
          if (!this.bankAccountNumberFirst) {
            return;
          }
          if (!this.bankAccountNumberLast) {
            return;
          }
        } else {
            this.username =
            this.cpfNO =
            this.agency =
            this.selBank =
            this.accountType =
            this.bankAccountNumberFirst =
            this.bankAccountNumberLast =
              "";
        }
      } else {
        if (this.speiFlag) {
          if (!this.bankCode) {
            return;
          }
          if (!this.clabe) {
            return;
          }
        }
      }
      this.commitRefundInfo(callBkObj);
    },
    // 提交退款相关的信息
    commitRefundInfo(ckObj) {
      let trade_no = this.$route.params.tid || localStorage.getItem("tid");
      if (trade_no === ckObj.orderId && ckObj.countCk > 1) {
        this.refundCanDo = false;
        return;
      }
      let token = localStorage.getItem("Authorization");
      const param = new FormData();
      param.append("trade_no", trade_no);
      param.append("amount", this.refundAmount);
      param.append("email", this.successfulEmail);
      param.append("desc", this.refundExplain);
      // param.append("clabe", this.clabe);
      // param.append("bank_code", this.bankCode);
      param.append("password", this.userPass);
      if (this.dispalyOtherFg) {
        param.append("identify", this.cpfNO.replace(".", "").replace("-", ""));
        param.append("username", this.username);
        let bankInfo = {
          bank_id: this.selBank.value,
          bank_name: this.selBank.description,
          agency: this.agency,
          type: "" + this.accountType.id,
          number:
            this.bankAccountNumberFirst.replace(/\s/g, "") +
            "-" +
            this.bankAccountNumberLast,
        };
        param.append("bank_info", JSON.stringify(bankInfo));
      }
      if (this.speiFlag) {
        let bankInfo = {
          bank_id: this.selectedBank.value,
          bank_name: this.selectedBank.label,
          number: this.clabe,
        }
        param.append("bank_info", JSON.stringify(bankInfo));
      }
      // 调试银行的信息 TODO
      // if (this.single.length === 1) {
      //   param.append('file', this.single[0])
      // }
      this.$refs.mediumModal.close();
      request({
        method: "post",
        url: `api/dashboard/order/refund?access_token=${token}`,
        data: param,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        ckObj.countCk++
        let code = res.data.code
        this.show = false;
        if (code == 10000) {
          this.toastText = res.data.msg || 'Success!'
          this.dialogTableVisible = false;
          this.launchToast()
          setTimeout(function() {
            this.loadingFullScreen("searching", "Searching", "fa fa-hourglass-half")
           this.orderData()
          }, 20);
        } else {
          this.toastText = res.data.sub_msg
          this.launchToast()
        }
      }).catch(err => {
        this.toastText = err.msg || "Business Failed"
        this.launchToast()
      });
    },
    handleModalClose() {
      this.clabe = ""
      this.bankCode = ""
    },
    isFormFieldValid(field) {
      let isValid = false;
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid;
      }
      return isValid;
    },
    resizeLabel(e) {
      e.currentTarget.style.paddingTop = "5px";
    },
    focusLabel(e) {
      e.currentTarget.style.paddingTop = "18px";
    },
    // 检查当前的现金支付是否可以退款
    checkCanRefund() {
      var refundChannels = [
        "Boleto",
        "Lottery",
        "DepositExpress",
        "PIX",
        "Pix",
        "SPEI",
      ];
      if (refundChannels.includes(this.orderInformation[0].method)) {
        if (this.speiFlag) {
          this.dispalyOtherFg = false;
          return true;
        } else {
          // this.checkboxOption = true;
          // this.dispalyOtherFg = true;
          return true;
        }
      }
      return false;
    },


  },
  computed: {
    isSuccessfulEmailValid() {
      let isValid = false;
      if (this.formFields.successfulEmail) {
        isValid =
          this.formFields.successfulEmail.validated &&
          this.formFields.successfulEmail.valid;
      }
      return isValid;
    },
  },
  watch: {
    checkboxOption: {
      handler: function (newVal, oldVal) {
        if (newVal === true) {
          this.dispalyOtherFg = true;
        } else {
          this.dispalyOtherFg = false;
        }
      },
      immediate: true,
      deep: true,
    },
  }
}
</script>
<style lang="scss" scoped>
.order-info {
  position: relative;
  .order-info-buttons {
    position: absolute;
    top: 10px;
    right: 40px;
  }
}
.table th {
  text-align: center;
}
.table td {
  text-align: center;
}
.table thead th {
  width: 300px;
}
.alink {
  color: $vue-green;
  text-decoration: underline;
}
</style>
